<template>
  <div class="download__container">
    <h1>Mazda Foto-App</h1>
    <template v-if="!fetching">
      <h2>Nun verfügbar: Version {{ latestVersion }}</h2>
      <Markdown v-if="rawChangelog !== ''" :data="rawChangelog"></Markdown>
      <div class="download__btn">
        <Button v-if="latestIosRelease !== ''" :href="latestIosRelease"
          >iOS</Button
        >
        <Button v-if="latestAndroidRelease !== ''" :href="latestAndroidRelease"
          >Android</Button
        >
      </div>
    </template>
  </div>
</template>

<script>
import Markdown from "./Markdown.vue";
import Button from "./Button.vue";

export default {
  name: "download-container",
  components: {
    Markdown,
    Button,
  },

  data() {
    return {
      fetching: false,
      latestVersion: "1.3.0",
      latestAndroidRelease:
        "https://app.bitrise.io/app/241241ab88c8814f/installable-artifacts/ba29b03aed19120b/public-install-page/8eff52e9c62d05ad8a090f47f9ef2b7f",
      latestIosRelease:
        "https://app.bitrise.io/app/241241ab88c8814f/installable-artifacts/f47d4ab47288e0c2/public-install-page/0fb7e4b22f607a3991b89a168bd9d159",
      rawChangelog: "",
    };
  },

  methods: {
    async fetchReleases() {
      try {
        const res = await fetch(
          location.protocol + "//app.fmm.mazda.de/mazdaphotomaker/releases/",
        );
        const json = await res.json();

        if (!("releases" in json)) {
          throw new Error();
        }

        const lastestRelease = json.releases[json.releases.length - 1];

        this.latestVersion = lastestRelease.version;
        this.latestAndroidRelease = "";
        this.latestIosRelease = "";
        /*
        this.latestAndroidRelease =
          "androidUrl" in lastestRelease
            ? "https://dmdr.io/mazdaphotomaker/download.php?platform=android&version=" +
              encodeURIComponent(lastestRelease.versionPath)
            : "";
        this.latestIosRelease =
          "iosUrl" in lastestRelease
            ? "https://dmdr.io/mazdaphotomaker/download.php?platform=ios&version=" +
              encodeURIComponent(lastestRelease.versionPath)
            : "";
*/
        if ("changelogUrl" in lastestRelease) {
          const resChangelog = await fetch(lastestRelease.changelogUrl);
          this.rawChangelog = await resChangelog.text();
        }

        this.fetching = false;
      } catch (err) {
        console.error(err);
      }
    },
  },

  mounted() {
    // this.fetchReleases();
  },
};
</script>

<style lang="scss" scoped>
.link {
  color: #ffffff;
}

.download__container {
  padding: 30px 30px 80px 30px;
  display: flex;
  flex-direction: column;
  flex: 1;

  @media screen and (min-width: 700px) {
    padding: 120px 130px;
    flex: 0;
  }

  h1 {
    color: #fff;
    font-size: 2.5rem;
    text-transform: uppercase;
    letter-spacing: 12px;
  }

  h2 {
    color: #fff;
    font-size: 1.1rem;
    text-transform: uppercase;
    letter-spacing: 5px;
    flex: 1;
  }

  .download__btn {
    display: flex;
    flex-direction: column;
    margin-top: 20px;

    @media screen and (min-width: 700px) {
      max-width: 300px;
      margin-top: 80px;
      padding-bottom: 0px;
    }

    *:not(:last-child) {
      margin-bottom: 20px;
    }
  }
}
</style>
